import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot } from '@angular/router'

import { EnvironmentService } from '@surgetech-eu/core'
import { environment } from 'src/environments/environment'

const KEYE = 'eyedes'
const CMPMAN = 'cmpman'

export class PlayerPermissions {
    canActivate(roles: string): boolean {
        return roles.includes(KEYE) || roles.includes(CMPMAN)
    }
}

@Injectable()
export class PlayerGuard {
    constructor(
        private environment: EnvironmentService,
        private permissions: PlayerPermissions
    ) {}

    canActivate(route: ActivatedRouteSnapshot): boolean {
        return this.permissions.canActivate(this.environment.get().type)
    }

    static get isKEYEorCMPMAN() {
        const roles = window['__env']?.type || environment.type
        return roles.includes(KEYE) || roles.includes(CMPMAN)
    }
}
